<template>
  <!-- Double check in order to hide the whole component -->
  <b-card v-if="minuteEventResolutionVotes.length > 0 || withVote">
    <b-row v-if="minuteEventResolutionVotes.length > 0" class="mb-2">
      <b-col>
        <b-row
          v-for="(minuteEvent, index) in minuteEventResolutionVotes"
          :key="index"
          :class="{ 'font-weight-bold': isBold(minuteEvent.majority_id) }"
        >
          <b-col class="d-flex align-items-center justify-content-between">
            <span :id="uniqId()" @click="attachTooltip($event, minuteEvent)">
              {{ $moment(toUtc(minuteEvent.date)).format("HH:mm:ss.SSS") }}
            </span>
            <div>
              <span
                type="button"
                @click="setCurrentResolutionMajorityId(minuteEvent.majority_id)"
                >{{
                  getMajorityFromVoteEvent(minuteEvent)
                    ? getMajorityFromVoteEvent(minuteEvent).name
                    : ""
                }}</span
              >
              <font-awesome-icon
                v-if="showVotesInfo"
                icon="info-circle"
                size="1x"
                class="mx-4 icon-click text-info"
                @click="openModalVoteInfo(index)"
              />
            </div>
          </b-col>

          <b-modal
            v-if="showModalsVoteInfo"
            :id="'modal-vote-info-' + index"
            size="xl"
            hide-footer
            centered
            @hide="showModalsVoteInfo = false"
          >
            <modalVoteInfo :minute-event="minuteEvent" />
          </b-modal>
        </b-row>
      </b-col>
    </b-row>

    <b-row v-if="withVote">
      <b-col>
        <b-row v-if="isPercentTypeTantiemes" class="mb-4">
          <b-col>
            <div class="mb-1">
              <span v-if="voteTypeForTantiemes == rulesOptions.forOrAgainst.for">
                Tantièmes en faveur de la résolution&nbsp;:
              </span>
              <span v-else>Tantièmes en défavorisé de la résolution&nbsp;:</span>
              <strong> {{ percentTantiemesCalculated }}&nbsp;% </strong>
            </div>
            <b-progress :max="100">
              <b-progress-bar
                :value="percentTantiemesCalculated"
                :variant="VOTE_RESULT ? 'success' : 'danger'"
                :label="displayProgressBarMessage()"
              />
            </b-progress>
          </b-col>
        </b-row>
        <b-row v-if="isPercentTypeVotes" class="mb-4">
          <b-col>
            <div class="mb-1">
              <span v-if="voteTypeForVotes == rulesOptions.forOrAgainst.for">
                Votes en faveur de la résolution&nbsp;:
              </span>
              <span v-else>Votes en défavorisé de la résolution&nbsp;:</span>
              <strong> {{ percentVotesCalculated }}&nbsp;% </strong>
            </div>
            <b-progress :max="100">
              <b-progress-bar
                :value="percentVotesCalculated"
                :variant="VOTE_RESULT ? 'success' : 'danger'"
                :label="displayProgressBarMessage()"
              />
            </b-progress>
          </b-col>
        </b-row>
        <b-row v-if="isPercentTypeNoCumulMandates">
          <b-col>
            <div class="mb-1">
              Votes en faveur de la résolution (no cumul mandates)&nbsp;:
              <strong> {{ percentNoCumulMandatesCalculated }}&nbsp;% </strong>
            </div>
            <b-progress :max="100">
              <b-progress-bar
                :value="percentNoCumulMandatesCalculated"
                :variant="VOTE_RESULT ? 'success' : 'danger'"
                :label="displayProgressBarMessage()"
              />
            </b-progress>
          </b-col>
        </b-row>

        <b-row v-if="showRevoteDetails">
          <b-col>
            <b-row>
              <b-col>
                Passerelle pour revote
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                Les conditions de majorité sont réunies
                <font-awesome-icon
                  :class="[REVOTE_RULES_RESULT ? 'text-success' : 'text-danger']"
                  :icon="REVOTE_RULES_RESULT ? 'check-circle' : 'times-circle'"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <hr />
        <b-row>
          <b-col cols="auto">
            <div class="w-100 d-inline-flex align-items-center">
              <div class="small-card">
                <font-awesome-icon icon="thumbs-up" size="2x" />
              </div>
              <div class="px-2">
                <div>
                  Pour
                </div>
                <div>
                  <strong>{{ getResolutionVotesFor(currentResolution.id).length }}</strong>
                  <b-badge variant="warning">
                    {{
                      getUsedVotesTantiemesByVotingCategory(
                        getResolutionVotesFor(currentResolution.id),
                        currentResolution.voting_category_id
                      )
                    }}
                  </b-badge>
                </div>
              </div>
            </div>
          </b-col>
          <b-col cols="auto">
            <div class="w-100 d-inline-flex align-items-center">
              <div class="small-card">
                <font-awesome-icon icon="thumbs-down" size="2x" />
              </div>
              <div class="px-2">
                <div>
                  Contre
                </div>
                <div>
                  <strong>{{ getResolutionVotesAgainst(currentResolution.id).length }}</strong>
                  <b-badge variant="warning">
                    {{
                      getUsedVotesTantiemesByVotingCategory(
                        getResolutionVotesAgainst(currentResolution.id),
                        currentResolution.voting_category_id
                      )
                    }}
                  </b-badge>
                </div>
              </div>
            </div>
          </b-col>
          <b-col cols="auto">
            <div class="w-100 d-inline-flex align-items-center">
              <div class="small-card">
                <font-awesome-icon icon="hand-paper" size="2x" />
              </div>
              <div class="px-2">
                <div>
                  Abstentions
                </div>
                <div>
                  <strong>{{ getResolutionVotesAbstain(currentResolution.id).length }}</strong>
                  <b-badge variant="warning">
                    {{
                      getUsedVotesTantiemesByVotingCategory(
                        getResolutionVotesAbstain(currentResolution.id),
                        currentResolution.voting_category_id
                      )
                    }}
                  </b-badge>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import minutesMixin from "@/mixins/minutes";
import AppTooltip from "@/components/snippets/Tooltip";
import Vue from "vue";
var uuid = require("uuid");

import { meetingMinutesNames } from "@/constants/meeting.js";

export default {
  components: {
    modalVoteInfo: () => import("@/components/modals/VoteInfo"),
  },
  mixins: [minutesMixin],
  props: {
    meeting: {
      type: Object,
      default: () => {
        return {};
      },
    },

    withVote: {
      type: Boolean,
      default: false,
    },
    currentResolution: {
      type: Object,
      default: () => {
        return {};
      },
    },
    majorityConditions: {
      type: Object,
      default: () => {
        return {};
      },
    },

    totalPresentOrRepresentedMandates: {
      type: Number,
      default: 0,
    },
    totalPresentOrRepresentedTantiemes: {
      type: Number,
      default: 0,
    },
    totalStrictPresentMandates: {
      type: Number,
      default: 0,
    },
    totalStrictPresentTantiemes: {
      type: Number,
      default: 0,
    },
    presentMandates: {
      type: Array,
      default: () => {
        return [];
      },
    },
    representedMandates: {
      type: Array,
      default: () => {
        return [];
      },
    },
    videoMandates: {
      type: Array,
      default: () => {
        return [];
      },
    },
    representedVideoMandates: {
      type: Array,
      default: () => {
        return [];
      },
    },
    correspondenceMandates: {
      type: Array,
      default: () => {
        return [];
      },
    },
    absentMandatesButVotedInPerson: {
      type: Array,
      default: () => {
        return [];
      },
    },
    absentMandatesButVoted: {
      type: Array,
      default: () => {
        return [];
      },
    },
    videoTantiemes: {
      type: Number,
      default: 0,
    },
    representedVideoTantiemes: {
      type: Number,
      default: 0,
    },
    correspondenceTantiemes: {
      type: Number,
      default: 0,
    },
    absentButVotedInPersonTantiemes: {
      type: Number,
      default: 0,
    },
    absentButVotedTantiemes: {
      type: Number,
      default: 0,
    },
    hasLackOfMajority: {
      type: Boolean,
      default: false,
    },
    currentResolutionIsInCorrectionMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      percentTantiemesCalculated: 0,
      percentVotesCalculated: 0,
      percentNoCumulMandatesCalculated: 0,
      showModalsVoteInfo: false,
    };
  },
  computed: {
    // Tantiemes, Votes or NoCumulMandates
    isPercentTypeTantiemes() {
      var isPercentTypeTantiemes = false;
      if (this.majorityConditions && this.majorityConditions.rules) {
        this.majorityConditions.rules.forEach(rule => {
          if (rule.majorityType == this.rulesOptions.majorityType.totalTantiemes)
            isPercentTypeTantiemes = true;
        });
      }
      return isPercentTypeTantiemes;
    },
    isPercentTypeVotes() {
      var isPercentTypeVotes = false;
      if (this.majorityConditions && this.majorityConditions.rules) {
        this.majorityConditions.rules.forEach(rule => {
          if (
            rule.majorityType == this.rulesOptions.majorityType.totalVotes &&
            rule.cumulMandates == this.rulesOptions.cumulMandates.withCumulMandates
          )
            isPercentTypeVotes = true;
        });
      }
      return isPercentTypeVotes;
    },
    isPercentTypeNoCumulMandates() {
      var isPercentTypeNoCumulMandates = false;
      if (this.majorityConditions && this.majorityConditions.rules) {
        this.majorityConditions.rules.forEach(rule => {
          if (
            rule.majorityType == this.rulesOptions.majorityType.totalVotes &&
            rule.cumulMandates == this.rulesOptions.cumulMandates.withoutCumulMandates
          )
            isPercentTypeNoCumulMandates = true;
        });
      }
      return isPercentTypeNoCumulMandates;
    },
    voteTypeForTantiemes() {
      let voteType = null;
      if (this.majorityConditions && this.majorityConditions.rules) {
        this.majorityConditions.rules.forEach(rule => {
          if (rule.majorityType == this.rulesOptions.majorityType.totalTantiemes) {
            voteType = rule.forOrAgainst;
          }
        });
      }
      return voteType;
    },
    voteTypeForVotes() {
      let voteType = null;
      if (this.majorityConditions && this.majorityConditions.rules) {
        this.majorityConditions.rules.forEach(rule => {
          if (rule.majorityType == this.rulesOptions.majorityType.totalVotes) {
            voteType = rule.forOrAgainst;
          }
        });
      }
      return voteType;
    },
    // TOTALS ****
    // TODO: ..
    votesForNoCumulMandates() {
      return 0;
    },
    // TODO: ..
    votesAgainstNoCumulMandates() {
      return 0;
    },
    // TODO: ..
    votesAbstainNoCumulMandates() {
      return 0;
    },

    // ???: kind of duplicate code, like in mixins/correspondence-votes.js (2021.10.20)
    VOTE_RESULT() {
      var result = false;
      var passed = [];
      if (this.majorityConditions) {
        this.majorityConditions.rules.forEach(rule => {
          let check = this.ITERATE_RULES(rule, true);

          passed.push(check);
        });
      }

      // check et/ou ..
      if (this.majorityConditions) {
        if (this.majorityConditions.rulesOperator == this.rulesOptions.rulesOperators.et) {
          result = this.$_.every(passed, item => {
            return item.passed && !item.lack_of_majority;
          });
        } else if (this.majorityConditions.rulesOperator == this.rulesOptions.rulesOperators.ou) {
          result = this.$_.some(passed, item => {
            return item.passed && !item.lack_of_majority;
          });
        }
      }

      const hasLackOfMajority = this.checkIfHasLackOfMajority(passed);

      this.$emit("voteResult", result, hasLackOfMajority);

      return result;
    },
    REVOTE_RULES_RESULT() {
      var result = false;
      var passed = [];
      if (this.majorityConditions) {
        this.majorityConditions.revoteRules.forEach(rule => {
          let check = this.ITERATE_RULES(rule);

          passed.push(check);
        });
      }

      // check et/ou ..
      // et
      if (this.majorityConditions) {
        if (this.majorityConditions.revoteRulesOperator == this.rulesOptions.rulesOperators.et) {
          result = this.$_.every(passed, item => {
            return item.passed;
          });
        }
        // ou
        else if (
          this.majorityConditions.revoteRulesOperator == this.rulesOptions.rulesOperators.ou
        ) {
          result = this.$_.some(passed, item => {
            return item.passed;
          });
        }
      }

      this.$emit("revoteRulesResult", result);

      return result;
    },
    minuteEventResolutionVotes() {
      return this.$_.filter(this.meeting.minutes, minute => {
        return (
          minute.event == meetingMinutesNames.resolution_vote &&
          (minute.resolution_id == this.currentResolution.id ||
            minute.resolution_id == this.currentResolution.parent_resolution_id)
        );
      });
    },

    showVotesInfo() {
      return (
        this.currentResolution.status != this.meetingResolutionStatuses.not_resolved &&
        this.currentResolution.status != this.meetingResolutionStatuses.sans_vote &&
        this.currentResolution.status != this.meetingResolutionStatuses.not_voted
      );
    },
    showRevoteDetails() {
      if (
        this.majorityConditions &&
        this.majorityConditions.revote &&
        !this.currentResolution.revote_majority_id
      ) {
        return true;
      }
      return false;
    },
  },
  watch: {
    // HACK: used to resolve vote all by correspondence issue when sans vote
    withVote(val) {
      if (!val) {
        this.$emit("voteResult", false);
      }
    },
  },
  methods: {
    // ???: duplicate code, like in mixins/correspondence-votes.js (2021.10.15)
    // !!!: .. VOTE CALCULATIONS
    ITERATE_RULES(rule, isForVote = false) {
      let result = {
        passed: false,
        lack_of_majority: false,
      };
      var r = rule;

      let values = {
        presentTantiemes: this.getUsedMandatesTantiemesByVotingCategory(
          this.presentMandates,
          this.currentResolution.voting_category_id
        ),
        representedTantiemes: this.getUsedMandatesTantiemesByVotingCategory(
          this.representedMandates,
          this.currentResolution.voting_category_id
        ),
        videoTantiemes: this.videoTantiemes,
        representedVideoTantiemes: this.representedVideoTantiemes,
        correspondenceTantiemes: this.correspondenceTantiemes,
        absentButVotedInPersonTantiemes: this.absentButVotedInPersonTantiemes,
        absentButVotedTantiemes: this.absentButVotedTantiemes,
        presentMandates: this.presentMandates,
        representedMandates: this.representedMandates,
        videoMandates: this.videoMandates,
        representedVideoMandates: this.representedVideoMandates,
        correspondenceMandates: this.correspondenceMandates,
        absentMandatesButVotedInPerson: this.absentMandatesButVotedInPerson,
        absentMandatesButVoted: this.absentMandatesButVoted,
      };

      if (r.majorityType == this.rulesOptions.majorityType.totalTantiemes) {
        if (r.forOrAgainst == this.rulesOptions.forOrAgainst.for) {
          result = this.CHECK_RULE(this.currentResolution, "tantiemes", "for", r, values);
        } else if (r.forOrAgainst == this.rulesOptions.forOrAgainst.against) {
          result = this.CHECK_RULE(this.currentResolution, "tantiemes", "against", r, values);
        }

        if (isForVote) this.percentTantiemesCalculated = result.percent;
      } else if (r.majorityType == this.rulesOptions.majorityType.totalVotes) {
        if (r.cumulMandates == this.rulesOptions.cumulMandates.withCumulMandates) {
          if (r.forOrAgainst == this.rulesOptions.forOrAgainst.for) {
            result = this.CHECK_RULE(this.currentResolution, "votes", "for", r, values);
          } else if (r.forOrAgainst == this.rulesOptions.forOrAgainst.against) {
            result = this.CHECK_RULE(this.currentResolution, "votes", "against", r, values);
          }

          if (isForVote) this.percentVotesCalculated = result.percent;
        }
        // TODO: w/o cumul mandates
        else if (r.cumulMandates == this.rulesOptions.cumulMandates.withoutCumulMandates) {
          if (r.forOrAgainst == this.rulesOptions.forOrAgainst.for) {
            result = this.CHECK_RULE(
              this.currentResolution,
              "votes-no-cumul-mandates",
              "for",
              r,
              values
            );
          } else if (r.forOrAgainst == this.rulesOptions.forOrAgainst.against) {
            result = this.CHECK_RULE(
              this.currentResolution,
              "votes-no-cumul-mandates",
              "against",
              r,
              values
            );
          }

          if (isForVote) this.percentNoCumulMandatesCalculated = result.percent;
        }
      }

      return result;
    },

    getMajorityFromVoteEvent(minuteEvent) {
      return this.findMajorityData(minuteEvent.majority_id);
    },
    openModalVoteInfo(index) {
      this.showModalsVoteInfo = true;
      this.$nextTick(() => {
        this.$bvModal.show("modal-vote-info-" + index);
      });
    },
    attachTooltip(e, data) {
      // NOTE: Edit time, only when resolution is in correction mode DEV-4820
      if (!this.currentResolutionIsInCorrectionMode) {
        return;
      }
      const TooltipClass = Vue.extend(AppTooltip);
      const tooltipInstance = new TooltipClass({
        propsData: {
          event: data,
          id: e.target.id,
        },
      });
      tooltipInstance.$mount(e.target.parent);
      tooltipInstance.$on("change", changeEvent => {
        this.changeMinuteEventDate(changeEvent.newDate, changeEvent.minuteEvent).then(() => {
          tooltipInstance.$destroy();
        });
      });
      tooltipInstance.$on("destroy-tooltip", () => {
        tooltipInstance.$destroy();
      });
    },
    uniqId() {
      return uuid.v4();
    },
    toUtc(date) {
      /*
       * This function will make sure that old meeting data that has no timezone will have UTC
       */
      if (date) {
        return this.$moment.parseZone(date).utcOffset(0, true).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
      } else {
        return date;
      }
    },
    displayProgressBarMessage() {
      if (!this.VOTE_RESULT && this.hasLackOfMajority) {
        return "Résultat : rejeté faute de majorité";
      } else if (!this.VOTE_RESULT) {
        return "Résultat : rejeté";
      } else {
        return "Résultat : accepté";
      }
    },
    checkIfHasLackOfMajority(passed) {
      return !!this.$_.some(passed, item => {
        return item.lack_of_majority;
      });
    },
    setCurrentResolutionMajorityId(majorityId) {
      this.$emit("changedCurrentResolutionMajorityId", majorityId);
    },
    isBold(majorityId) {
      return (
        (this.currentResolution.majority_id === majorityId &&
          this.currentResolution.revote_majority_id === null) ||
        this.currentResolution.revote_majority_id === majorityId
      );
    },
  },
};
</script>
